<template>
  <div class="page_socialInsurance">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="100px">
            <el-form-item label="账单月" size="small">
              <el-date-picker v-model="listQuery.billingMonth" type="month" value-format="yyyyMM" placeholder="" size="small" style="width:180px" @change="changeBillingMonth"></el-date-picker>
            </el-form-item>
            <el-form-item label="账户类型" size="small">
              <el-select v-model="listQuery.accountType" placeholder="" filterable clearable size="small" style="width: 180px;">
                <el-option value="自有账户"></el-option>
                <el-option value="供应商代参"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="参保账户" size="small">
              <!-- <el-input v-model="listQuery.insuredAccountFullName" size="small" clearable style="width:180px"></el-input> -->
              <el-select v-model="listQuery.insuredAccountFullName" placeholder="" size="small" style="width: 180px;" clearable filterable>
                <el-option v-for="(item, index) in legList" :key="index" :value="item.name"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen == 1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="100px">
          <el-form-item label="供应商" size="small">
            <el-input v-model="listQuery.supplierFullName" size="small" clearable style="width:180px"></el-input>
          </el-form-item>
          <el-form-item label="参保省市区:" prop="serveProvince">
            <el-cascader :props="propsAddress" filterable ref="cascaderArr" clearable v-model="address" :options="areaList" @change="changeAreaHandle" size="small" style="width: 180px;"></el-cascader>
          </el-form-item>
          <el-form-item label="项目名称" size="small">
            <el-select v-model="listQuery.project" placeholder="" clearable filterable size="small" style="width:180px">
              <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="导入人" size="small" v-if="activeName2=='0'">
            <el-input v-model="listQuery.importer" size="small" clearable style="width:180px"></el-input>
          </el-form-item>
          <el-form-item label="姓名" size="small" v-if="activeName2=='2'">
            <el-input v-model="listQuery.name" size="small" clearable style="width:180px"></el-input>
          </el-form-item>
          <el-form-item label="身份证" size="small" v-if="activeName2=='2'">
            <el-input v-model="listQuery.idCardNumber" size="small" clearable style="width:180px"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle()">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen = -1">关闭</el-button>
        <el-button v-preventReClick size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>雇员</el-breadcrumb-item>
          <el-breadcrumb-item>社保</el-breadcrumb-item>
          <el-breadcrumb-item>{{ activeName }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="ftabs">
        <socialTab ref="child"></socialTab>
        <el-tabs v-model="listQuery.billType" @tab-click="changeTab2">
          <el-tab-pane label="财务汇总" v-if="checkPermission(['socialBill-financial'], this.permissionLists)" name="财务"></el-tab-pane>
          <el-tab-pane label="客服汇总" v-if="checkPermission(['socialBill-customer'], this.permissionLists)" name="客服"></el-tab-pane>
        </el-tabs>
        <el-tabs v-model="activeName2" @tab-click="changeTab2">
          <el-tab-pane label="按账户" name="0"></el-tab-pane>
          <el-tab-pane label="按项目" name="1"></el-tab-pane>
          <el-tab-pane label="按人员" name="2"></el-tab-pane>
        </el-tabs>

        <div class="ftabBtn flex">
          <el-button type="primary" size="small" @click="expList" :loading="isExping" v-if="checkPermission(['socialBill_export'], this.permissionLists)">导出</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%" v-if="activeName2 != 2">
          <el-table-column prop="billingMonth" key="1" label="账单月" min-width="80" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="accountType" key="2" label="账户类型" min-width="80" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <!-- <el-table-column prop="billType" key="2.1" label="账单属性" min-width="80" :show-overflow-tooltip="true" align="center">
          </el-table-column> -->
          <el-table-column prop="insuredAccountFullName" key="3" label="参保账户全称" min-width="240" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="supplierFullName" key="4" label="供应商名称" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="insuredProvince" key="5" label="参保地（省）" min-width="110" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="insuredCity" key="6" label="参保地（市）" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="insuredDistrict" key="7" label="参保地（区）" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="project" key="7.5" v-if="activeName2=='1'" label="项目名称" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="socialSecurityPersonnelCount" key="8" label="社保人员数量" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="socialSecurityAmount" key="9" label="社保金额" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="publicFundPersonnelCount" key="10" label="公积金人员数量" min-width="112" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="socialPublicFundAmount" key="10.5" label="公积金金额" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="otherExpenses" key="11" label="其他费用" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="serviceFee" key="12" label="服务费" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="totalAmount" key="12.1" label="合计金额" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="importer" key="13" label="导入人" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="import_date" key="14" label="导入时间" min-width="120" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>{{ row.import_date ? row.import_date.replace('T', ' ') : '' }}</template>
          </el-table-column>
          <el-table-column prop="import_batch_number" key="15" label="导入批次号" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center" min-width="100" fixed="right">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" @click="getDtl(row)">明细</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <tableDtl v-if="activeName2 == 2" v-loading="loading" :tableData="tableData"></tableDtl>

        <div class="block">
          <el-pagination v-if="totalCount > 0" @current-change="currentChange" :current-page.sync="listQuery.pagination.Page" :page-size="Number(listQuery.pagination.pageSize)" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <div class="dialogBox">
      <el-dialog title="明细" :visible.sync="showDtl" width="1100px">
        <tableDtl v-loading="loading" :tableData="dtlData"></tableDtl>
        <div class="block">
          <el-pagination v-if="totalCount2>0" @current-change="currentChange2" :current-page.sync="dtlQuery.pageNum" :page-size="Number(dtlQuery.pageSize)" @size-change="handleSizeChange2" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount2"></el-pagination>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="showDtl = false">关 闭</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import xz from "../../common";
  import tableDtl from "./components/tableDtl.vue"
  import socialTab from "./components/socialTab.vue"
  import checkPermission from '@/utils/permission' // 权限判断函数
  import moment from "moment";
  export default {
    components: {
      tableDtl,
      socialTab
    },
    data() {
      return {
        listQuery: {
          pagination: {
            pageSize: 10,
            Page: 1,
            OrderInput: [{
              property: "createTime",
              order: 1
            }]
          },
          id: '',
          billType: '财务',
          billingMonth: '', //账单月
          accountType: '', //账户类型
          insuredAccountFullName: '', //参保账户
          supplierFullName: '', //供应商
          insuredProvince: '', //省
          insuredCity: '', //
          insuredDistrict: '', //区
          project: '', //项目
          name: '', //
          employeePhone: '', //员工手机号
          idCardNumber: '', //身份证
          formOwner: '', //
          affiliatedCompany: '', //
          invoicingCompany: '', //
          importer: '',
          LoginUserId: Cookies.get("userid-b"),
          founder: Cookies.get("userid-b")
        },
        proNameList: [],
        showDropScreen: -1,
        activeName: '社保账单',
        tableData: [],
        customerList: [],
        roletype: localStorage.loginRoletype,
        totalCount: 0,
        loading: false,
        activeName2: '0',
        isExping: false,
        isBtnLoading: false,
        address: [],
        areaList: [], //省市区列表
        propsAddress: {
          label: 'Name',
          value: 'Name',
          children: 'children',
        },
        showDtl: false,
        dtlData: [],
        dtlQuery: {
          PageModel: {
            Rows: 10,
            Page: 1,
            OrderInput: [{
              property: "createTime",
              order: 1
            }]
          },
          id: '',
          billtype: '',
          founder: Cookies.get("userid-b")
        },
        totalCount2: 0,
        permissionLists: [],
        legList: [],
      }
    },
    created() {
      if (this.$route.query.id != undefined && this.$route.query.id) {
        this.id = this.$route.query.id;
      }
      this.listQuery.billingMonth = moment().subtract(1, 'months').format('YYYYMM');
      this.getButtonPower();
      this.getprovinces();
      this.getProList();
      this.getlegalsubjectlist()
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let d = {
          path: '/socialBill',
          powerEnName: 'socialBill'
        }
        xz.getbtnPowerIdBypage(d).then(res => {
          // console.log('按钮',res)
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                this.permissionLists.push(element.Enname);
              }
              if (!this.checkPermission(['socialBill'], this.permissionLists)) {
                if (this.checkPermission(['importBill'], this.permissionLists)) {
                  this.$router.push({
                    path: '/importBill?active=账单导入'
                  })
                } else {
                  this.$router.push({
                    path: '/payFees?active=缴费标准'
                  })
                }
              }
              if (!this.checkPermission(['socialBill-financial'], this.permissionLists)) {
                this.listQuery.billType = '客服'
              }
            } else {
              this.permissionLists = []
            }
            this.getList();
          } else {
            this.permissionLists = []
          }
        })
      },
      //获取法务主体列表
      getlegalsubjectlist() {
        let d = {
          userid: Cookies.get("userid-b"),
          companyName: '',
          isCanInsure: false,
          pageNum: 1,
          pageSize: 1000
        }
        xz.ArdCurStat(d, 'GetUserLegalList').then(res => {
          if (res.status == 'ok') {
            this.legList = res.data.date;
          } else {
           this.legList = [];
          }
        })
      },
      //判断是否为空(包含0)
      isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN';
      },
      //获取项目
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.proNameList = res.msg;
          } else {
            this.proNameList = [];
          }
        });
      },
      resetHandle() {
        this.listQuery = this.$options.data.call(this).listQuery;
      },
      currentChange(val) {
        this.listQuery.pagination.Page = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pagination.Page = 1;
        this.listQuery.pagination.pageSize = val;
        this.getList();
      },
      searchHandle() {
        this.listQuery.pagination.Page = 1;
        this.getList();
      },
      getList() {
        let pagename = this.activeName2 == '0' ? 'GetSocialSecurityBillList' : this.activeName2 == '1' ? 'GetSocialSecurityBillOfProjectList' : 'GetSocialSecurityBillAllList';
        this.loading = true;
        if(this.listQuery.billingMonth == null){
          this.listQuery.billingMonth = ''
        }
        xz.SocialFun(this.listQuery, pagename, 'post').then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.data;
            this.totalCount = res.data.totalCount;
            this.loading = false;
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.loading = false;
          }
        })
      },
      changeAreaHandle(val) {
        if (val.length == 3) {
          this.listQuery.insuredProvince = val[0]
          this.listQuery.insuredCity = val[1]
          this.listQuery.insuredDistrict = val[2]
        } else {
          this.listQuery.insuredProvince = '';
          this.listQuery.insuredCity = '';
          this.listQuery.insuredDistrict = '';
        }
      },
      //获取省市区
      getprovinces() {
        xz.getAreaAll().then(res => {
          this.areaList = res;
        })
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      changeTab() {
        // if (this.activeName == '社保账单') {
        // }else if(this.activeName == '账单导入') {}
      },
      changeTab2() {
        // if (this.activeName2 == '0' || this.activeName2 == '1') {
        //   this.listQuery = {
        //     PageModel: {
        //       Rows: 10,
        //       Page: 1,
        //       OrderInput: [{
        //         property: "createTime",
        //         order: 0
        //       }]
        //     },
        //     id: '',
        //     billingMonth: '', //账单月
        //     accountType: '', //账户类型
        //     insuredAccountFullName: '', //参保账户
        //     supplierFullName: '', //供应商
        //     insuredProvince: '', //省
        //     insuredCity: '', //
        //     insuredDistrict: '', //区
        //     project: '', //项目
        //     name: '', //
        //     employeePhone: '', //员工手机号
        //     idCardNumber: '', //身份证
        //     formOwner: '', //
        //     affiliatedCompany: '', //
        //     invoicingCompany: '' //
        //   }
        // } else {

        // }
        this.getList();
      },
      getDtl(row) {
        if (this.listQuery.billType == '客服' && this.activeName2 == '1') {
          this.dtlQuery.billingMonth = row.billingMonth;
          this.dtlQuery.accountType = row.accountType;
          this.dtlQuery.insuredAccountFullName = row.insuredAccountFullName;
          this.dtlQuery.supplierFullName = row.supplierFullName;
          this.dtlQuery.project = row.project;
          this.dtlQuery.billType = row.billType;
        } else {
          this.dtlQuery = this.$options.data.call(this).dtlQuery;
        }
        this.dtlQuery.id = row.batchId;
        this.dtlQuery.PageModel.Page = 1;
        this.getDtlList();
        this.showDtl = true;
      },
      //获取明细列表
      getDtlList() {
        this.loading = true;
        this.dtlQuery.billtype = this.listQuery.billType;
        xz.SocialFun(this.dtlQuery, 'GetImportSocialSecurityBatchDetailPageList', 'post').then(res => {
          if (res.status == 'ok') {
            this.dtlData = res.data.data;
            this.totalCount2 = res.data.pageModel.totalCount;
            this.loading = false;
          } else {
            this.dtlData = [];
            this.totalCount2 = 0;
            this.loading = false;
          }
        })
      },
      currentChange2(val) {
        this.dtlQuery.PageModel.Page = Number(val);
        this.getDtlList();
      },
      handleSizeChange2(val) {
        console.log(`每页 ${val} 条`);
        this.dtlQuery.PageModel.Page = 1;
        this.dtlQuery.PageModel.Rows = val;
        this.getDtlList();
      },
      expList() {
        let pagename = this.activeName2 == '0' ? 'ExportImportSocialSecurityBatchDetailInput' : this.activeName2 == '1' ? 'ExportSocialBatchProjectPageList' : 'ExportImportSocialSecurityBatchDetailPageList/download';
        this.isExping = true;
        let d = JSON.parse(JSON.stringify(this.listQuery));
        delete d.PageModel;
        if (this.activeName2 == '2') {
          d.filename = `${this.activeName}-${this.activeName2==0 ? '按账户' : this.activeName2=='1' ? '按项目' : '按人员'}${this.listQuery.insuredAccountFullName ? '-' + this.listQuery.insuredAccountFullName : ''}${this.listQuery.billingMonth ? '-' + this.listQuery.billingMonth : ''}.xlsx`
        }
        xz.SocialExpFun(d, pagename).then(res => {
          if (res) {
            try {
              var data = new Blob([res], {
                type: "application/vnd.ms-excel;charset=utf-8"
              });
              var downloadUrl = window.URL.createObjectURL(data);
              var anchor = document.createElement("a");
              anchor.href = downloadUrl;
              anchor.download = `${this.activeName}-${this.activeName2==0 ? '按账户' : this.activeName2=='1' ? '按项目' : '按人员'}${this.listQuery.insuredAccountFullName ? '-' + this.listQuery.insuredAccountFullName : ''}${this.listQuery.billingMonth ? '-' + this.listQuery.billingMonth : ''}.xlsx`;
              anchor.click();
              window.URL.revokeObjectURL(data);
              this.isExping = false;
            } catch (e) {
              this.isExping = false;
              this.$message.error('导出异常')
            }
          } else {
            this.$message.error('导出失败');
            this.getList();
            this.isExping = false;
          }
        })
      },
      changeBillingMonth(val) {
        if (val == null) {
          this.listQuery.billingMonth = '';
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 10px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .calTitle {
    font-size: 14px;
    font-weight: bold;
  }

  .titleLine {
    font-size: 16px;
    color: #F59A23;
    margin-right: 3px;
  }

  .calList {
    padding-left: 40px;
    margin-top: 20px;
  }

  .calItem {
    margin-bottom: 10px;
  }

  .record {
    margin-top: 10px;
    color: #797979;
  }

  .checkedgroup {
    display: flex;
    /* flex-flow: wrap; */
  }

  .pro_down_box {
    padding-left: 29px;
  }

  .errTips {
    font-size: 16px;
    margin-bottom: 10px;
  }
</style>
<style>
  .page_socialInsurance .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_socialInsurance .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_socialInsurance .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_socialInsurance .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_socialInsurance .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_socialInsurance .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_socialInsurance .checkedgroup .el-checkbox {
    margin-right: 10px;
  }

  .page_socialInsurance .el-checkbox__label {
    padding-left: 3px;
  }

  .page_socialInsurance .checkedgroup2 .el-checkbox {
    margin-bottom: 5px;
  }

  .page_socialInsurance .dialogBox .el-dialog__body {
    padding: 20px 20px 5px 20px;
  }
</style>